import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Environment } from '@rma/public/generic/util/environment';
import { injectTransferOnce } from '@rma/public/generic/util/http';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly httpClient = inject(HttpClient);
  private readonly environment = inject(Environment);
  private readonly window = inject<Window>(WA_WINDOW);
  private readonly transferOnce = injectTransferOnce();

  public getTranslation(locale: string, data?: { scope: string }) {
    // replace the last occurance of - with _
    const localePath = locale.replace(/(\s*-)(?![\s\S]*-)/, '_');

    const { url, site } = this.environment.language;
    const assetsLangJson = data?.scope ? `${url}/scope/${localePath}.json` : `${url}/site/${site ?? 'public'}/${localePath}.json`;
    const showKeys = this.window.location.search.includes('doesthismakeyouhappyanton');
    if (showKeys) {
      return of({});
    }

    // A scope first needed when a hydrate block fires arrives after the HTTP transfer cache has closed.
    return this.transferOnce(
      `transloco:${assetsLangJson}`,
      this.httpClient.get<Translation>(assetsLangJson, { transferCache: false }),
    ).pipe(catchError(() => of({})));
  }
}
